import React from "react";

const blogs = [
  {
    img: "/images/keyword/1.jpg",
    date: { day: "22", month: "JAN" },
    title: "Mumbai Outstation Cabs",
    url: "/mumbai-outstation-cabs",
    desc: "Book reliable Mumbai outstation cabs for safe, comfortable, and affordable long-distance travel anytime.",
  },
  {
    img: "/images/keyword/3.jpg",
    date: { day: "09", month: "MAY" },
    title: "Mumbai to Goa Cabs",
    url: "/mumbai-to-goa-cabs",
    desc: "Experience a smooth Mumbai to Goa cab journey with clean cars, skilled drivers, and budget-friendly fares.",
  },
  {
    img: "/images/keyword/15.jpg",
    date: { day: "08", month: "APR" },
    title: "Mumbai to Matheran Cab",
    url: "/mumbai-to-matheran-cab",
    desc: "Enjoy a relaxing Mumbai to Matheran cab ride with reliable service, comfortable vehicles, and fair pricing.",
  },
];

const NewsSection = () => {
  return (
    <section className="news-section section-padding section-bg-2">
      <div className="container">

        {/* Title */}
        <div className="section-title text-center">
          <span className="wow fadeInUp" data-wow-delay=".3s">
            Latest Blog & News
          </span>

          <h2 className="wow fadeInUp" data-wow-delay=".5s">
            Latest Travel Insights and <br />
            Destination Guides
          </h2>
        </div>

        {/* Blog Cards */}
        <div className="row">
          {blogs.map((blog, index) => (
            <div
              key={index}
              className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp"
              data-wow-delay={`.${3 + index * 2}s`}
            >
              <div className="news-box-items-4">

                {/* Image */}
                <div className="news-img">
                  <img src={blog.img} alt={blog.title} />
                </div>

                {/* Content */}
                <div className="news-content">
                  {/* <ul>
                    <li>
                      <b>By</b> Admin
                    </li>
                    <li>
                      <b>23</b> Comments
                    </li>
                  </ul> */}

                  <h3>
                    <a href={blog.url}>{blog.title}</a>
                  </h3>

                  <p>{blog.desc}</p>

                  <a href={blog.url} className="link-btn">
                    Continue Reading{" "}
                    <i className="fa-solid fa-arrow-right"></i>
                  </a>
                </div>

              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default NewsSection;